import { render, staticRenderFns } from "./rjcpzx2.vue?vue&type=template&id=f4e730d4&scoped=true&"
import script from "./rjcpzx2.vue?vue&type=script&lang=js&"
export * from "./rjcpzx2.vue?vue&type=script&lang=js&"
import style0 from "./rjcpzx2.vue?vue&type=style&index=0&id=f4e730d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e730d4",
  null
  
)

export default component.exports